
import Vue from 'vue';
import {PaymentStatusInterface} from "~/store/paymentStatus";

export default Vue.extend({
  name: 'OrderReceivedPage',
  head: {
    title: 'Reserveringsbevestiging - CHEFSTBL',
  },
  data(): { paymentStatus: PaymentStatusInterface | null, title: string, text: string } {
    return {
      paymentStatus: null,
      title: "",
      text: "",
    }
  },
  async fetch() {
    const id = this.$route.params.id
    const key = this.$route.query.key

    this.paymentStatus = await this.$axios.$get<{ data: PaymentStatusInterface }>(`/v1/order/payment-status/${id}/${key}`).then(data => data.data);

    if (this.paymentStatus) {
      if (this.paymentStatus.state === 'completed') {
        this.title = 'Reserveringsbevestiging';
        this.text = `Bedankt, je reservering is bevestigd op ${this.paymentStatus.paid_at}. De chef neemt snel contact met je op om het menu af te stemmen.`;
      } else {
        this.title = 'Reservering status';
        this.text = this.paymentStatus.state === 'pending' ? 'In afwachting' : this.paymentStatus.state;
      }
    }
  }
})
